import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalEditFormString, optionalEditFormTrimmedString, optionalEnumIdString, } from '../zod-helpers/index.js';
import { ADDRESS_CONSTRAINTS } from './constraints.js';
const requiredEditFormPart = (label, maxLength) => z.string().trim().min(1, `${label} is required.`).max(maxLength).optional();
export function buildAddressEditFormSchema(allowedTypes, invalidTypeMessage = 'Invalid address type.', { requireFullAddress = false } = {}) {
    // WHY: an edit form may leave a field untouched, so strictness means a cleared field is
    // rejected -- not that every field must be present in the payload.
    const parts = requireFullAddress
        ? {
            city: requiredEditFormPart(ADDRESS_CONSTRAINTS.city.label, ADDRESS_CONSTRAINTS.city.maxLength),
            stateId: z.string().trim().min(1, 'State is required.').optional(),
            countryId: z.string().trim().min(1, 'Country is required.').optional(),
            zip: requiredEditFormPart(ADDRESS_CONSTRAINTS.zip.label, ADDRESS_CONSTRAINTS.zip.maxLength),
        }
        : {
            city: optionalEditFormTrimmedString(ADDRESS_CONSTRAINTS.city.maxLength),
            stateId: optionalEditFormString(),
            countryId: optionalEditFormString(),
            zip: optionalEditFormTrimmedString(ADDRESS_CONSTRAINTS.zip.maxLength),
        };
    return z.object({
        addressName: z
            .string()
            .trim()
            .min(1, `${capitalize(ADDRESS_CONSTRAINTS.addressName.label.toLowerCase())} is required.`)
            .max(ADDRESS_CONSTRAINTS.addressName.maxLength)
            .optional(),
        typeId: optionalEnumIdString(allowedTypes, invalidTypeMessage).optional(),
        address: z
            .string()
            .trim()
            .min(1, `${capitalize(ADDRESS_CONSTRAINTS.address.label.toLowerCase())} is required.`)
            .max(ADDRESS_CONSTRAINTS.address.maxLength)
            .optional(),
        ...parts,
        defaultFlag: z.boolean().optional(),
    });
}
//# sourceMappingURL=update-form.js.map